module.exports = __webpack_public_path__ + "media/images/thejumper-logo-e777f0328b9fe808db4018033038ac2d.png";